"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingWindow = exports.BookingFormModelProvider = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const announce_popup_1 = require("../app/components/announce/announce_popup");
const client_account_1 = require("../model/client_account");
const auth_1 = require("../utils/auth");
const helpers_1 = require("../utils/helpers");
const rest_provider_1 = require("../utils/rest_provider");
const ajax_1 = require("../widgets/ajax");
const duration_picker_1 = require("../widgets/duration_picker");
const form_for_1 = require("../widgets/form_for");
const modal_1 = require("../widgets/modal");
const calendar_1 = require("./calendar");
var lockingStatus = "failure";
var hoursAvailable = 0;
exports.BookingFormModelProvider = new rest_provider_1.RestProvider({
    name: "booking_form_model",
    create: "POST|/bookings",
    update: "PATCH|/bookings/:id",
    show: "GET|/bookings/:id",
    delete: "DELETE|/bookings/:id",
    index: "GET|/bookings",
    new: "GET/bookings/new"
});
var venueList = [];
var clientList = [];
var roomIndex = new Map();
function fetchVenueList() {
    app_1.App.get("/venues/rooms/list").then((data) => {
        venueList = data;
        venueList.forEach(venue => {
            venue.rooms.forEach(room => {
                roomIndex.set("" + room.id, room);
            });
        });
        mithril_1.default.redraw();
    });
}
function fetchClients() {
    auth_1.Auth.adminOnly(() => {
        app_1.App.get("/clients/list?scope=active_contract").then((data) => {
            clientList = data;
        });
    });
}
function fetchPreferences(data) {
    auth_1.Auth.clientOnly(() => {
        client_account_1.ClientAccountProvider.show(0).then((info) => {
            data.additional_services = info.default_hardware;
        });
    });
}
function errorMessage() {
    if (exports.BookingWindow.data.client_id === undefined && auth_1.Auth.isAdmin())
        return "Veuillez selectionner un client.";
    if (hoursAvailable < exports.BookingWindow.data.duration)
        return "Pas assez d'heure dans le forfait du client";
    return "L'heure selectionne est déjà vérrouillée. Merci d'essayer un autre créneau.";
}
function renderLockStatus() {
    switch (lockingStatus) {
        case "loading":
            return (0, mithril_1.default)(ajax_1.Loading);
        case "failure":
            return (0, helpers_1.messageBlock)("danger", [
                (0, mithril_1.default)("div", { style: "text-align: center" }, (0, helpers_1.iconSpan)("fa-hand-paper fa-3x")),
                (0, mithril_1.default)("p", errorMessage())
            ]);
        case "ok":
            return (0, helpers_1.messageBlock)("success", (0, mithril_1.default)("div", { style: "text-align: center" }, (0, helpers_1.iconSpan)("fa-check fa-3x")));
        default:
            return undefined;
    }
}
function updateLock() {
    let data = exports.BookingWindow.data;
    let startsAt = data.day;
    lockingStatus = "loading";
    if (auth_1.Auth.isAdmin()) {
        if (data.client_id) {
            app_1.App.get(`/booking/check-availability?room=${data.room_id}` +
                `&client_id=${data.client_id}&date=${startsAt.toISOString()}&duration=${data.duration}`).then((data) => {
                lockingStatus = data.available ? "ok" : "failure";
                hoursAvailable = data.hours_remaining;
            }).catch((_data) => {
                lockingStatus = "failure";
            });
        }
        else {
            lockingStatus = "failure";
        }
    }
    else {
        app_1.App.get(`/booking/check-availability?room=${data.room_id}` +
            `&date=${startsAt.toISOString()}&duration=${data.duration}`).then((data) => {
            lockingStatus = data.available ? "ok" : "failure";
            hoursAvailable = data.hours_remaining;
        }).catch((_data) => {
            lockingStatus = "failure";
        });
    }
}
function getVenue(id) {
    for (let i in venueList) {
        if (venueList[i].id == id) {
            return venueList[i];
        }
    }
    return undefined;
}
function getClients() {
    return clientList.map((client) => {
        return [client.id, [client.first_name, client.last_name].join(" ") + " (" + client.id + ")"];
    });
}
function getRoomsForVenues(idx) {
    for (let i in venueList) {
        if (venueList[i].id == idx) {
            return venueList[i].rooms.map((room) => {
                return [room.id, room.name];
            });
        }
    }
    return undefined;
}
function renderServices(form) {
    let roomId = form.obj.room_id;
    let room;
    form.obj.additional_services = form.obj.additional_services || [];
    let additional_services = form.obj.additional_services;
    if (roomId && (room = roomIndex.get("" + roomId))) {
        if (room.available_hardware.length == 0) {
            form.obj.additional_services = [];
            return undefined;
        }
        let authorizedServices = (0, helpers_1.fastIntersection)(additional_services, room.available_hardware);
        let toRemove = [];
        for (let idx = 0; idx < additional_services.length; idx++) {
            if (authorizedServices.indexOf(additional_services[idx]) == -1) {
                toRemove.push(idx);
            }
        }
        toRemove.reverse().forEach(idx => { authorizedServices.splice(idx, 1); });
        let array = room.available_hardware.map(hw => {
            // Naive find into array structure
            // in our case perf is not big issue
            // as there's only few services avail. for each rooms.
            return (0, form_for_1.checkbox)(hw, "additional_hardware", form.obj, {
                checked: additional_services.indexOf(hw) != -1,
                oninput: (_e) => {
                    let idx = additional_services.indexOf(hw);
                    if (idx != -1) {
                        additional_services.splice(idx, 1);
                    }
                    else {
                        additional_services.push(hw);
                    }
                }
            });
        });
        let out = [];
        if (room.available_hardware.length > 0) {
            out.push((0, mithril_1.default)("div", (0, mithril_1.default)("h3", "Materiel demandé")));
            (0, helpers_1.eachSlice)(array, 3, (slice) => {
                out.push((0, form_for_1.columns)(...slice));
            });
            out.push((0, mithril_1.default)("div", (0, mithril_1.default)("hr")));
        }
        return out;
    }
    return undefined;
}
function renderForm(form) {
    let venue = getVenue(form.obj.venue_id);
    let planningStartsAt, planningEndsAt;
    if (venue) {
        planningStartsAt = (0, helpers_1.strToMinutes)(venue.planning_starts_at);
        planningEndsAt = (0, helpers_1.strToMinutes)(venue.planning_ends_at);
    }
    let day = form.obj.day;
    let timeInDay = 60, maxDuration = 600;
    if (day) {
        timeInDay = day.hour() * 60 + day.minute();
        maxDuration = (planningEndsAt || 0) - timeInDay;
        form.obj.duration = Math.min(form.obj.duration, maxDuration);
    }
    return [
        form.errorBlock(),
        auth_1.Auth.adminOnly((0, form_for_1.columns)(form.selectField("Client", "client_id", getClients(), { afterchange: (_obj, newValue, oldValue) => {
                if (oldValue !== undefined && newValue !== oldValue) {
                    app_1.App.get(`/booking/clear_lock?client_id=${oldValue}`).then(updateLock);
                }
                else {
                    updateLock();
                }
            }, class: "is-fullwidth" }))),
        (0, form_for_1.mobileColumns)(
        //form.selectField("Établissement", "venue_id", getVenues(), {afterchange: updateLock, class: "is-fullwidth"}),
        form.selectField("Salle", "room_id", getRoomsForVenues(form.obj.venue_id), { afterchange: updateLock, class: "is-fullwidth" })),
        (0, form_for_1.hr)(),
        renderServices(form),
        (0, helpers_1.ifTrue)((0, helpers_1.isMobile)(), [
            renderLockStatus(),
            (0, form_for_1.mobileColumns)(renderTimeOfBooking(timeInDay, planningStartsAt, planningEndsAt, form), renderDurationOfBooking(form, maxDuration))
        ], (0, form_for_1.mobileColumns)(renderLockStatus(), renderTimeOfBooking(timeInDay, planningStartsAt, planningEndsAt, form), renderDurationOfBooking(form, maxDuration))),
        auth_1.Auth.clientOnly([
            form.textarea([
                (0, mithril_1.default)("div", "Note personnelle"),
                (0, mithril_1.default)(".hint", "Cette note est confidentielle, accessible par vous uniquement")
            ], "client_comment"),
            form.textarea([
                (0, mithril_1.default)("div", "Message pour Sésame"),
            ], "shared_comment"),
        ]),
        auth_1.Auth.adminOnly(form.textarea([
            (0, mithril_1.default)("div", "Note Sesame"),
            (0, mithril_1.default)(".hint", "Cette note est confidentielle, accessible par Sésame uniquement")
        ], "company_comment")),
        (0, form_for_1.hr)()
    ];
}
exports.BookingWindow = {
    data: {},
    active: false,
    open(day, venueId, roomId) {
        exports.BookingFormModelProvider.clearError();
        exports.BookingWindow.data = {};
        exports.BookingWindow.data.day = day.clone();
        exports.BookingWindow.data.duration = 60;
        exports.BookingWindow.data.venue_id = venueId;
        exports.BookingWindow.data.room_id = roomId;
        exports.BookingWindow.data.additional_services = [];
        exports.BookingWindow.active = true;
        updateLock();
        fetchPreferences(this.data);
    },
    oncreate(_vnode) {
        fetchVenueList();
        fetchClients();
    },
    view(_vnode) {
        let form = (0, form_for_1.formFor)(this.data, exports.BookingFormModelProvider, function (form) {
            let day = form.obj.day, dayStr = "...";
            if (day)
                dayStr = day.format("DD MMM YYYY");
            return (0, modal_1.modalCard)({
                title: `Nouvelle réservation - ${dayStr}`,
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Réserver", {
                    disabled: (lockingStatus != "ok"),
                    onsubmit: (data) => {
                        exports.BookingWindow.active = false;
                        calendar_1.Calendar.refresh();
                        //FastAccessContract.refresh()
                        auth_1.Auth.clientOnly(() => {
                            if (data.has_announces) {
                                announce_popup_1.AnnouncePopup.show(data.booking.id);
                            }
                        });
                    }
                }), (0, mithril_1.default)("button", { class: "button", onclick: (e) => {
                        e.preventDefault();
                        exports.BookingWindow.active = false;
                    } }, "Annuler")),
                isActive: exports.BookingWindow.active,
                onClose: () => { exports.BookingWindow.active = false; }
            });
        });
        return form;
    }
};
function renderDurationOfBooking(form, maxDuration) {
    return [
        (0, mithril_1.default)("h3", { style: "text-align: center;" }, "Durée de la réservation"),
        (0, mithril_1.default)(duration_picker_1.DurationPicker, {
            value: form.obj.duration || 60,
            minDuration: app_1.App.BOOKING_MIN_DURATION,
            maxDuration: maxDuration,
            step: 30,
            onchange: (v) => {
                form.obj.duration = v;
                updateLock();
            }
        })
    ];
}
function renderTimeOfBooking(timeInDay, planningStartsAt, planningEndsAt, form) {
    return [(0, mithril_1.default)("h3", { style: "text-align: center;" }, "Heure de la réservation"),
        (0, mithril_1.default)(duration_picker_1.DurationPicker, {
            value: timeInDay || planningStartsAt,
            minDuration: planningStartsAt,
            maxDuration: (planningEndsAt || app_1.App.BOOKING_MIN_DURATION) - app_1.App.BOOKING_MIN_DURATION,
            step: app_1.App.BOOKING_STEP,
            onchange: (v) => {
                let newDate = form.obj.day.clone();
                newDate.startOf('day');
                newDate.hour(Math.floor(v / 60));
                newDate.minutes(v % 60);
                form.obj.day = newDate;
                updateLock();
            }
        })
    ];
}
